import { render, staticRenderFns } from "./splitOrder.vue?vue&type=template&id=a197e296&scoped=true"
import script from "./splitOrder.vue?vue&type=script&lang=js"
export * from "./splitOrder.vue?vue&type=script&lang=js"
import style0 from "./splitOrder.vue?vue&type=style&index=0&id=a197e296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a197e296",
  null
  
)

export default component.exports